import React, { useEffect, useState } from "react"
// MUI
import {Button, Grid, Typography, TextField} from "@mui/material"
import SendIcon from "@mui/icons-material/Send"
// style
import {style} from "./style"

export default function QRCodeEmail(props: any) {

    const {fieldDisplay} = props

    const subject: string = encodeURIComponent(fieldDisplay.subject as string);
    const body: string = encodeURIComponent(fieldDisplay.body as string);

    const [emailBody, setEmailBody] = useState("")
    const [formattedBody, setFormattedBody] = React.useState("")

    const mailTo: string = `mailto:${fieldDisplay.to}?subject=${subject}&body=${formattedBody}`
    const editable: boolean = fieldDisplay.is_body_editable

    const formatBody = (str: string) => {
        return str.replaceAll("\n", "%0D%0A").replaceAll("\r", "%0D%0A")
    }

    useEffect(() => {
        setEmailBody(fieldDisplay.body)
    }, [body]);

    useEffect(() => {
        if (!!emailBody) setFormattedBody(formatBody(emailBody))
    }, [emailBody])

    return (
        <Grid item xs={12}>
            <Typography variant={'body1'} sx={style.mainWrapper}>
                <strong>To:</strong> {fieldDisplay.to}
            </Typography>
            <Typography variant={'body1'} sx={style.subject}>
                <strong>Subject:</strong> {fieldDisplay.subject}
            </Typography>

            <Typography variant={'body1'} sx={style.message}>
                <strong>Message:</strong>
            </Typography>

            <TextField
                fullWidth
                value={emailBody}
                onChange={(e: any) => setEmailBody(e.currentTarget.value)}
                multiline
                inputProps={{
                    readOnly: !editable,
                }}
                minRows={4}
            />

            <Grid container justifyContent={'center'} justifyItems={'center'}>
                <Grid item xs={8} md={4} sx={style.buttonWrapper}>
                    <Button
                        variant={'contained'}
                        sx={style.button}
                        href={mailTo}
                        target={'_blank'}
                    >
                        <SendIcon style={style.icon}/> Send
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
